import { useEffect } from 'react'

import store from 'redux/store'

import { useAuth } from 'hooks/UseAuth'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { UserService } from 'api/clients/UserService'

const WORKSPACE_MEMBERS_COUNT_CHANNEL = 'WorkspaceMembersCountChannel'

enum WorkspaceMembersCountChannelPayloadAction {
  UpdateWorkspaceMembersCount = 'update_workspace_members_count',
}

interface PayloadData {
  members_count: number
}

interface WorkspaceMembersCountChannelPayload {
  action: WorkspaceMembersCountChannelPayloadAction
  data: PayloadData
}

export const useSyncWorkspaceMembersCount = (workspaceId: number) => {
  const auth = useAuth()
  const websocketConnection = useWebsocketConnection()
  const { workspaces } = store.getState().workspace

  useEffect(() => {
    if (!auth || !websocketConnection || !workspaceId) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: WORKSPACE_MEMBERS_COUNT_CHANNEL, workspace_id: workspaceId },
      {
        received({ action, data }: WorkspaceMembersCountChannelPayload) {
          if (action === WorkspaceMembersCountChannelPayloadAction.UpdateWorkspaceMembersCount && data.members_count) {
            const updatedWorkspaces = workspaces.map((workspace) => {
              if (workspace.id === workspaceId) {
                const { members_count } = data
                return {
                  ...workspace,
                  members_count,
                }
              }

              return workspace
            })

            UserService.setWorkspaces(updatedWorkspaces)
          }
        },
      },
    )
    return () => subscription.unsubscribe()
  }, [auth, websocketConnection, workspaceId, workspaces])
}
